import React, { useState } from "react"
import Button from "./Button"
import Input from "./Input"
import Icon from "../AppIcon"
import { authHelpers } from "../../firebaseClient"

// Generic "confirm with password" modal for sensitive org actions
// (publish, delete, role changes, etc). Controlled from the parent:
// pass `open`, a `label` describing the action, `onConfirm`, and `onClose`.
const ReauthModal = ({ open, label, onConfirm, onClose }) => {
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")
  const [verifying, setVerifying] = useState(false)

  if (!open) return null

  const handleClose = () => {
    setPassword("")
    setError("")
    setVerifying(false)
    onClose?.()
  }

  const handleConfirm = async (e) => {
    e?.preventDefault()
    if (!password) {
      setError("Enter your password to continue.")
      return
    }

    setVerifying(true)
    setError("")

    const { error: reauthError } = await authHelpers.reauthenticate(password)

    setVerifying(false)

    if (reauthError) {
      setError("Incorrect password. Please try again.")
      return
    }

    setPassword("")
    await onConfirm?.()
  }

  return (
    <div className="fixed inset-0 z-drawer flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-black bg-opacity-50" onClick={handleClose} />

      <form
        onSubmit={handleConfirm}
        className="relative bg-card border border-border rounded-xl shadow-lg w-full max-w-sm p-6"
      >
        <div className="flex items-center gap-2 mb-3">
          <Icon name="ShieldCheck" size={18} className="text-accent" />
          <h2 className="text-sm font-semibold text-foreground">Confirm your password</h2>
        </div>

        <p className="text-sm text-muted-foreground mb-4">
          For security, please confirm your password to {label || "continue"}.
        </p>

        <Input
          type="password"
          label="Password"
          value={password}
          onChange={(e) => setPassword(e?.target?.value)}
          autoFocus
        />

        {error && <p className="text-xs text-destructive mt-2">{error}</p>}

        <div className="flex items-center justify-end gap-3 mt-5">
          <Button type="button" variant="ghost" onClick={handleClose}>
            Cancel
          </Button>
          <Button type="submit" variant="default" loading={verifying}>
            Confirm
          </Button>
        </div>
      </form>
    </div>
  )
}

export default ReauthModal